var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPersonToPersonColoured = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24813_10608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2642 8.06801C16.1622 8.06801 16.0589 8.03242 15.9761 7.95951C14.8718 6.99117 13.4596 6.45801 12.0001 6.45801C10.6246 6.45801 9.27941 6.94042 8.21191 7.81717C8.02466 7.97059 7.74875 7.94317 7.59591 7.75651C7.44308 7.56984 7.46991 7.29392 7.65658 7.14051C8.87983 6.13601 10.4227 5.58301 12.0001 5.58301C13.6719 5.58301 15.2889 6.19317 16.553 7.30151C16.7344 7.46076 16.7525 7.73726 16.5932 7.91926C16.5069 8.01726 16.3856 8.06801 16.2642 8.06801Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22884 7.91639H7.77051C7.52901 7.91639 7.33301 7.72039 7.33301 7.47889V6.02055C7.33301 5.8438 7.43976 5.68397 7.60309 5.6163C7.76642 5.54864 7.95484 5.58597 8.07967 5.71139L9.53801 7.16972C9.66284 7.29455 9.70076 7.48297 9.63309 7.6463C9.56542 7.80964 9.40559 7.91639 9.22884 7.91639Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0701 18.4167C10.3977 18.4167 8.78067 17.8065 7.51717 16.6982C7.33517 16.539 7.31767 16.2625 7.47692 16.0805C7.63617 15.899 7.91267 15.881 8.09467 16.0402C9.19834 17.0085 10.61 17.5417 12.0701 17.5417C13.4456 17.5417 14.7908 17.0593 15.8583 16.1825C16.0449 16.0285 16.3203 16.056 16.4743 16.2432C16.6277 16.4299 16.6003 16.7058 16.4136 16.8592C15.1903 17.8637 13.6474 18.4167 12.0701 18.4167Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2292 18.4154C16.1155 18.4154 16.0035 18.371 15.9201 18.287L14.4617 16.8287C14.3369 16.7039 14.299 16.5154 14.3667 16.3521C14.4343 16.1888 14.5942 16.082 14.7709 16.082H16.2292C16.4707 16.082 16.6667 16.278 16.6667 16.5195V17.9779C16.6667 18.1546 16.56 18.3144 16.3967 18.3821C16.3424 18.4043 16.2858 18.4154 16.2292 18.4154Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9161 11.9987C8.72151 11.9987 9.37443 11.3458 9.37443 10.5404C9.37443 9.73495 8.72151 9.08203 7.9161 9.08203C7.11068 9.08203 6.45776 9.73495 6.45776 10.5404C6.45776 11.3458 7.11068 11.9987 7.9161 11.9987Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22917 12.582H6.60417C5.71925 12.582 5 13.3013 5 14.1862V14.4779C5 14.7194 5.196 14.9154 5.4375 14.9154H10.3958C10.6373 14.9154 10.8333 14.7194 10.8333 14.4779V14.1862C10.8333 13.3013 10.1141 12.582 9.22917 12.582Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 11.9987C16.8887 11.9987 17.5417 11.3458 17.5417 10.5404C17.5417 9.73495 16.8887 9.08203 16.0833 9.08203C15.2779 9.08203 14.625 9.73495 14.625 10.5404C14.625 11.3458 15.2779 11.9987 16.0833 11.9987Z",
    fill: "#BE56D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3959 12.582H14.7709C13.886 12.582 13.1667 13.3013 13.1667 14.1862V14.4779C13.1667 14.7194 13.3627 14.9154 13.6042 14.9154H18.5626C18.8041 14.9154 19.0001 14.7194 19.0001 14.4779V14.1862C19.0001 13.3013 18.2808 12.582 17.3959 12.582Z",
    fill: "#BE56D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24813_10608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPersonToPersonColoured);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_person_to_person_coloured.51da10d6cd97cae91559f2319f70420e.svg";